// Single source of truth for the optional "secondary" columns each OrderItem
// row supports. These are the user-entered extra fields shown only when the
// merchant explicitly enables them via the column settings modal.
//
// Mirrors the backend `OrderItem::SECONDARY_COLUMNS` (app/models/order_item.rb).
// Keep this list in sync with the backend constant — values must match exactly.
//
// Adding a new column:
//   1. Add to `OrderItem::SECONDARY_COLUMNS` on the backend.
//   2. Add to this tuple. The Record<…> typing on OrderItemsForm's `fieldConfig`
//      will then force a render config to be supplied.
//   3. Add `models.order_item.<name>` i18n key.
//
// Carrier code (OrderItemsForm.buildItem) uses Object.fromEntries on this
// tuple, so new columns are automatically preserved across inventory swaps
// and row splits — no caller changes needed.
export const ORDER_ITEM_SECONDARY_COLUMNS = [
  'price',
  'note',
  'identifier',
  'original_price',
  'internal_note',
  'cost',
] as const;

export type OrderItemSecondaryColumn = typeof ORDER_ITEM_SECONDARY_COLUMNS[number];
